import React from 'react';
import { useTranslation } from 'react-i18next';

import { calculateHeight } from '../statisticsParentUtils';

import './style.scss';

const classes = Array.from({ length: 11 }, (_, i) => i + 1).concat(['OtherClasses']);

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const AllStatisticsStudents = ({ parentObj, hidenAgesRow = false, textTop, totalCount }) => {
  const { t } = useTranslation();

  return (
    <div className="all-statistics-students-materials-block">
      <div className="statistics-students-materials-text">
        <span className="statistics-students-materials-count">{`${totalCount} ${t(textTop)}`}</span>
      </div>
      <div className="all-statistics-students-materials-block-content">
        <div className="statistics-students-materials-block-top">
          {!hidenAgesRow && (
            <ul className="statistics-age-list">
              {classes.map(classItem => (
                <li key={classItem}>
                  <div className="item-age">
                    <div className="item-age-numb">{classItem !== 'OtherClasses' ? classItem : ''}</div>
                    <div className="item-age-numb">{classItem !== 'OtherClasses' ? t('class') : t('OtherClasses')}</div>
                  </div>
                  <div className="item-count">{parentObj.classObj[classItem]}</div>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="statistics-students-materials-block-bottom">
          <ul className="all-statistics-lines-bg">
            {new Array(4).fill(null).map((_, i) => (
              <li key={i} />
            ))}
          </ul>

          <ul className="statistics-students-materials-list">
            {months.map(month => (
              <li key={month}>
                <div
                  className="pilar-item"
                  style={{
                    height: calculateHeight(parentObj.monthObj[month]) + '%',
                  }}
                >
                  <div className="pilar-count">{parentObj.monthObj[month]}</div>
                </div>
                <div className="pilar-month">
                  <span>{t(month)}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
